import { Theme } from '@/types/theme'

export enum FEATURE {
  ASK_PHONE_FOR_REMINDER = 'askPhoneForReminder'
}

export interface Config {
  theme?: Theme
  languageScreenMandatory: boolean

  meta?: {
    title?: string
    description?: string
  }

  consultation?: {
    // Consultation related configuration goes here
  }

  defaultValues?: {
    user?: {
      physicianCountry?: string
      language?: string
      location?: string
      origin?: string
      country?: string
      weightUnit?: string
    }
  }

  features?: FEATURE[]
}
